<div class="dashboard">
    <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-4">
            <div class="overview-box monthly-sales">
                <div class="overview-title">TOTAL USERS</div>
                <!-- <i class="fa fa-arrow-circle-up"></i> -->
                <div class="overview-numbers">
                    <strong>{{ucount | number}}</strong>
                </div>

                <!-- <img src="assets/layout/images/icon-sales.png" alt="california-layout" /> -->
            </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-4">
            <div class="overview-box monthly-views">
                <div class="overview-title">TOTAL PATIENTS
                    <!-- <i class="fa fa-arrow-circle-down"></i> -->
                </div>
                <div class="overview-numbers">
                    <strong>{{pcount | number}}</strong>
                </div>

                <!-- <img src="assets/layout/images/icon-views.png" alt="california-layout" /> -->
            </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-4">
            <div class="overview-box monthly-users">
                <div class="overview-title">TOTAL CONSULTATIONS
                    <!-- <i class="fa fa-arrow-circle-up"></i> -->
                </div>
                <div class="overview-numbers">
                    <strong>{{ccount | number}}</strong>
                </div>

                <!-- <img src="assets/layout/images/icon-users.png" alt="california-layout" /> -->
            </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-4" *ngIf="this.is_primary_provider">
            <div class="overview-box monthly-sales">
                <div class="overview-title">TOTAL VENDORS</div>
               
                <div class="overview-numbers">
                    <strong>{{vcount | number}}</strong>
                </div>
                
            </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-4">
            <div class="overview-box monthly-views">
                <div class="overview-title">TOTAL DOCTORS
                    <!-- <i class="fa fa-arrow-circle-down"></i> -->
                </div>
                <div class="overview-numbers">
                    <strong>{{dcount | number}}</strong>
                </div>
                <!-- <img src="assets/layout/images/icon-views.png" alt="california-layout" /> -->
            </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-4">
            <div class="overview-box monthly-users">
                <div class="overview-title">TOTAL SPECIALITIES
                    <!-- <i class="fa fa-arrow-circle-up"></i> -->
                </div>
                <div class="overview-numbers">
                    <strong>{{scount | number}}</strong>
                </div>
                <!-- <img src="assets/layout/images/icon-users.png" alt="california-layout" /> -->
            </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-4" *ngIf="!this.is_primary_provider">
            <div class="overview-box monthly-users">
                <div class="overview-title">TOTAL COUNTRIES
                    <!-- <i class="fa fa-arrow-circle-up"></i> -->
                </div>
                <div class="overview-numbers">
                    <strong>{{countrycount | number}}</strong>
                </div>
                <!-- <img src="assets/layout/images/icon-users.png" alt="california-layout" /> -->
            </div>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-6">
            <p-panel styleClass="chart" header="Top 10 Countries by Patient Count">
                <p-chart type="pie" [data]="patientCountData"></p-chart>
                <div class="text-center">
                    <strong>Total Patients: {{ totalPatients | number }}</strong>
                </div>
                
            </p-panel>   
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-6">
            <p-panel styleClass="chart" header="Top 10 Specialities by Consultation Count">
                <p-chart type="bar" [data]="consultationCountData"></p-chart>
                <div class="text-center">
                    <strong>Total Count: {{ totalCount | number }}</strong>
                </div>
            </p-panel>
        </div>

        <!-- <div class="ui-g-12 ui-md-12 ui-lg-6">
            <p-panel header="Inventory" styleClass="inventory">
                <p-table [columns]="cols" selectionMode="single" dataKey="vin"
                    [(selection)]="selectedCar" [responsive]="true" [paginator]="true" [rows]="10">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            <td *ngFor="let col of columns">
                                {{rowData[col.field]}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-panel>
        </div> -->
    </div>
</div>